module.exports = {
  PURCHASE_ORDER: 'purchase-order',
  REPAIRE_ORDER: 'repair-order',
  UNIT: 'unit',
  LICENCE_PLATE: 'licence-plate',
  VIN: 'vin',
  CONTACT: 'contact',
};
